import { Box, Typography } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useDispatch } from "react-redux";
import AppService from "../../Configurations/Appservice";
import { dismissLoader, showLoader } from "../../LayoutContainers/AppLayout/redux/AppSlice";
import pxToRem from "../../Themes/Functions/pxToRem";
import { saveAs } from "file-saver";
import WDButton from "../../MaterialComponents/WDButton";

const ViewDocument = (props) => {
  const { label, url, fileName } = props;
  const dispatch = useDispatch();

  const _downloadFile = (url, viewType) => {
    dispatch(showLoader());
    AppService({
      url: `v1/file/download?fileUrl=${url}`,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        if (viewType && viewType === "SHOW") {
          var fileURL = URL.createObjectURL(response);
          window.open(fileURL);
        } else {
          saveAs(response, fileName);
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  };

  return (
    <WDButton
      variant="text"
      style={{ fontSize: "10px" }}
      underline="hover"
      onClick={() => _downloadFile(url, "SHOW")}
    >
      View uploaded {label}
    </WDButton>
  );
};

export default ViewDocument;
